package br.com.vvrefeicoes.portal.core.ui.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import br.com.vvrefeicoes.portal.core.ui.layout.AppScrollbar
import br.com.vvrefeicoes.portal.core.ui.theme.AppShapes
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing
import com.composables.icons.lucide.Lucide
import com.composables.icons.lucide.X
import org.jetbrains.compose.resources.stringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.dismiss

@Composable
fun AppModalCard(
    title: String,
    onDismiss: () -> Unit,
    wide: Boolean = false,
    content: @Composable ColumnScope.() -> Unit,
) {
    Dialog(
        onDismissRequest = onDismiss,
        properties = DialogProperties(usePlatformDefaultWidth = !wide),
    ) {
        BoxWithConstraints {
            val scrollState = rememberScrollState()
            val widthModifier =
                if (wide) {
                    Modifier.widthIn(
                        min = maxWidth * 0.5f,
                        max = minOf(maxWidth * 0.95f, 1200.dp),
                    )
                } else {
                    Modifier
                }
            Surface(
                modifier =
                    Modifier
                        .heightIn(max = maxHeight * 0.9f)
                        .then(widthModifier),
                shape = AppShapes.large,
                color = Color.White,
            ) {
                Box {
                    Column(
                        modifier =
                            Modifier
                                .verticalScroll(scrollState)
                                .padding(AppSpacing.space24),
                        verticalArrangement = Arrangement.spacedBy(AppSpacing.space16),
                    ) {
                        Text(
                            text = title,
                            style = MaterialTheme.typography.titleLarge,
                            modifier = Modifier.padding(end = AppSpacing.space32),
                        )
                        content()
                    }
                    AppScrollbar(
                        state = scrollState,
                        modifier =
                            Modifier
                                .align(Alignment.CenterEnd)
                                .fillMaxHeight()
                                .padding(vertical = AppSpacing.space8),
                    )
                    IconButton(
                        onClick = onDismiss,
                        modifier =
                            Modifier
                                .align(Alignment.TopEnd)
                                .padding(AppSpacing.space8),
                    ) {
                        Icon(
                            imageVector = Lucide.X,
                            contentDescription = stringResource(Res.string.dismiss),
                            tint = MaterialTheme.colorScheme.onSurfaceVariant,
                        )
                    }
                }
            }
        }
    }
}
